// extracted by mini-css-extract-plugin
export default {"cuisine":"Option_cuisine__YrK16"};